module.exports = __webpack_public_path__ + "static/media/MovingApp_android_6.c6aedfa1.jpg";